const zh_TW = {
  "hyvendor.img.login": "images/img-bb.jpg",
  "hyvendor.header": "自助售書機",
  "hyvendor.title.login": "使用者登入",
  "hyvendor.title.cust": "個人書房",
  "hyvendor.title.book": "書籍清單",
  "hyvendor.title.open": "完成取書",
  "hyvendor.title.admin": "後台管理",
  "hyvendor.title.adminin": "排櫃",
  "hyvendor.title.adminout": "下架",
  "hyvendor.title.adminall": "調整",
  "hyvendor.menu.renew": "我要續借",
  "hyvendor.menu.renewed": "續借結果",
  "hyvendor.menu.loanlist": "借閱清單",
  "hyvendor.menu.reservedlist": "預約清單",
  "hyvendor.menu.admin": "後台管理",
  "hyvendor.menu.adminin": "排櫃",
  "hyvendor.menu.adminout": "下架",
  "hyvendor.menu.adminall": "調整",
  "hyvendor.column.second": "秒",
  "hyvendor.column.title": "書名",
  "hyvendor.column.author": "作者",
  "hyvendor.column.publisher": "出版項",
  "hyvendor.column.edition": "版本項",
  "hyvendor.column.barcode": "條碼號",
  "hyvendor.column.callnumber": "索書號",
  "hyvendor.column.keepdate": "保留日期",
  "hyvendor.column.vailddate": "有效日期",
  "hyvendor.column.bookorder": "順位",
  "hyvendor.column.duedate": "到期",
  "hyvendor.column.day": "天",
  "hyvendor.column.locker": "櫃位",
  "hyvendor.column.overdue": "已逾期",
  "hyvendor.column.keepsitename": "館藏地",
  "hyvendor.column.readercode": "讀者證號",
  "hyvendor.column.readername": "讀者姓名",
  "hyvendor.column.bookinfo": "書籍資訊",
  "hyvendor.column.abstract": "簡介",
  "hyvendor.button.next": "下一步",
  "hyvendor.button.reset": "清除重填",
  "hyvendor.button.cancel": "取消",
  "hyvendor.button.ok": "確定",
  "hyvendor.button.close": "關閉",
  "hyvendor.button.cancelexit": "取消離開",
  "hyvendor.button.donein": "完成上架",
  "hyvendor.button.doneout": "完成下架",
  "hyvendor.button.open": "開啟櫃門",
  "hyvendor.button.login": "登入",
  "hyvendor.button.take": "我要借閱",
  "hyvendor.button.lend": "借閱書籍",
  "hyvendor.button.cust": "個人書房",
  "hyvendor.button.procout": "書籍下架",
  "hyvendor.button.procin": "書籍上架",
  "hyvendor.button.usekeyinlogin": "使用讀者證號、密碼登入",
  "hyvendor.button.donecontinue": "繼續借書",
  "hyvendor.button.donetake": "取書完成，離開",
  "hyvendor.placeholder.password": "請輸入密碼",
  "hyvendor.placeholder.username": "請輸入讀者證號",
  "hyvendor.status.renew": "我要續借",
  "hyvendor.status.unrenewable": "不可續借",
  "hyvendor.status.renewed": "已續借",
  "hyvendor.status.load": "已選取",
  "hyvendor.status.ready": "已上架",
  "hyvendor.status.empty": "空櫃",
  "hyvendor.status.opened": "開啟",
  "hyvendor.status.error": "故障",
  "hyvendor.status.maintain": "維修",
  "hyvendor.message.book": "請點選欲借閱書籍櫃號",
  "hyvendor.message.renew": "請再次確認是否續借此書！確認後將無法取消。",
  "hyvendor.message.forgotcard": "忘記帶證件了嗎？",
  "hyvendor.message.logininfo":
    "請使用借閱證讀取條碼或使用縣民卡感應來進行登入。",
  "hyvendor.message.open1": "目前書櫃已開啟！請到",
  "hyvendor.message.open2": "櫃取書，取書後請關閉櫃門，感謝您的使用。",
  "hyvendor.error.login": "您輸入的證號無效，請洽圖書館管理者查詢。",
  "hyvendor.error.noselected": "請先點選書籍",
  "hyvendor.error.syserror": "系統錯誤",
  "hyvendor.error.dooropened": "請關好櫃門後繼續",
  "hyvendor.error.nobook": "查無此書籍",
  "hyvendor.error.bookstatus": "此書籍狀態不可上架",
  "hyvendor.footer":
    "讀者有系統或操作問題時，可於圖書館開放時間至流通櫃檯尋求館員協助。",
  "hyvendor.soldout":
    "本次新書已被選購完畢，{br}將儘速補充新書，{br}造成不便請見諒，{br}謝謝大家支持。",
};

export default zh_TW;
